<div class="grid">
  <div
    class="d-flex align-items-center"
    [ngClass]="
      searchSetting ? 'justify-content-between' : 'justify-content-end'
    ">
    @if (searchSetting) {
      <div class="d-flex justify-content-start mb-3">
        <ap-search
          styleClass="p-0"
          [placeholder]="'admin.grid.searchFieldPlaceholder' | translate"
          [searchType]="'primary'"
          (onSearch)="search($event)"></ap-search>
      </div>
    }

    @if (
      hasCreateButton ||
      showToolbarDownloadButton ||
      showToolbarDownloadAllButton
    ) {
      <div class="d-flex justify-content-end mb-3 gap-2">
        @if (showToolbarDownloadAllButton) {
          <div
            class="grid__toolbar-icon-combined"
            ap-tooltip
            direction="top"
            [tooltipContent]="
              'admin.grid.exportDownloadAllTooltip' | translate
            ">
            <ap-button
              icon="globe-map-outline"
              [add]="true"
              (onClick)="toolbarDownloadAllClick()" />
            <span
              class="Appkit4-icon icon-arrow-down-outline ap-font-10"></span>
          </div>
        }
        @if (showToolbarDownloadButton) {
          <ap-button
            icon="download-outline"
            [add]="true"
            ap-tooltip
            direction="top"
            [tooltipContent]="'admin.grid.exportDownloadTooltip' | translate"
            (onClick)="toolbarDownloadClick()" />
        }
        @if (hasCreateButton) {
          <ap-button
            icon="plus-outline"
            [add]="true"
            (onClick)="createActionClick()" />
        }
      </div>
    }
  </div>
  @if (dataSource.length !== 0 || noDataMessage || !this.filterIsEmpty()) {
    <ap-table
      #table
      [(data)]="dataSource"
      [disableDefaultSort]="true"
      [condensed]="true"
      (onSort)="sort($event)"
      class="grid__table"
      [showSelectAll]="hasCheckboxButton">
      <table>
        <thead>
          <tr>
            @if (hasCheckboxButton) {
              <th>
                <ap-checkbox
                  class="ap-table-checkbox-container"
                  (onChange)="toggleAllSelections(selectAll)"
                  [(ngModel)]="selectAll">
                </ap-checkbox>
              </th>
            }
            @if (
              hasViewButton ||
              hasEditButton ||
              hasDeleteButton ||
              hasCustomButtons
            ) {
              <th>
                <gstar-grid-header
                  [title]="'admin.grid.actionsColumnName' | translate" />
              </th>
            }
            @for (header of headers; track header) {
              @if (isCheckboxColumn(header)) {
                <th [style.width.px]="header.width">
                  <div class="d-flex align-items-center gap-2">
                    <ap-checkbox
                      class="ap-table-checkbox-container"
                      [ngModel]="allClientSelectedFor(header.key)"
                      (ngModelChange)="
                        toggleAllClientSelection(header.key, $event)
                      ">
                    </ap-checkbox>
                    <gstar-grid-header [title]="header?.label" />
                  </div>
                </th>
              } @else if (header.isSortable) {
                <th
                  ap-sort
                  [sortKey]="header.key"
                  [style.width.px]="header.width">
                  <gstar-grid-header [title]="header?.label" />
                </th>
              } @else {
                <th [style.width.px]="header.width">
                  <gstar-grid-header [title]="header?.label" />
                </th>
              }
            }
            @if (tooltips) {
              <th>
                <gstar-grid-header [title]="tooltips.header" />
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of table.data; track row) {
            <tr [class.selected]="row.selected">
              @if (hasCheckboxButton) {
                <td>
                  <ap-checkbox
                    (onChange)="onSelectionChange(row)"
                    class="ap-table-checkbox-container"
                    [(ngModel)]="row.isChecked">
                  </ap-checkbox>
                </td>
              }

              @if (hasViewButton || hasEditButton || hasDeleteButton) {
                <td>
                  <div class="grid__table__actions">
                    @if (hasViewButton) {
                      <button
                        type="button"
                        class="grid__table__actions__buttons p-0"
                        (click)="viewModalHandler(row)">
                        <span class="Appkit4-icon icon-view-outline"></span>
                      </button>
                    }

                    @if (hasEditButton) {
                      <button
                        type="button"
                        class="grid__table__actions__buttons p-0"
                        (click)="editActionClick(row)"
                        [disabled]="disabledButton(row)">
                        <span class="Appkit4-icon icon-edit-outline"></span>
                      </button>
                    }

                    @if (hasDeleteButton) {
                      <button
                        type="button"
                        class="grid__table__actions__buttons p-0"
                        (click)="deleteModalHandler(row)">
                        <span class="Appkit4-icon icon-delete-outline"></span>
                      </button>
                    }

                    @for (actionButton of actionButtons; track actionButton) {
                      <button
                        type="button"
                        ap-tooltip
                        direction="top"
                        [tooltipContent]="actionButton.label"
                        class="grid__table__actions__buttons p-0"
                        (click)="actionButton.command(row)">
                        <span
                          class="Appkit4-icon"
                          [ngClass]="actionButton.icon"></span>
                      </button>
                    }
                  </div>
                </td>
              }

              @for (header of headers; track header) {
                <td>
                  @if (isCheckboxColumn(header)) {
                    <ap-checkbox
                      class="ap-table-checkbox-container"
                      [ngModel]="booleanCellValue(row, header.key)"
                      (ngModelChange)="
                        setClientBooleanSelection(row, header.key, $event)
                      ">
                    </ap-checkbox>
                  } @else if (isReadOnlyBooleanCheckboxColumn(header)) {
                    <ap-checkbox
                      class="ap-table-checkbox-container"
                      [ngModel]="booleanCellValue(row, header.key)"
                      [disabled]="true">
                    </ap-checkbox>
                  } @else if (header.dataType === templateColumnType) {
                    <gstar-grid-template-factory
                      [header]="header"
                      [row]="toGridRow(row)" />
                  } @else {
                    <span>{{
                      row | gridRowIterator: header.key : header.dataType
                    }}</span>
                  }
                </td>
              }
              @if (tooltips) {
                <td>
                  <span
                    ap-tooltip
                    tooltipId="tooltipDesc"
                    ariaDescribedby="tooltipDesc"
                    direction="top"
                    [tooltipContent]="tooltips.label(row)"
                    class="ap-font-16 Appkit4-icon"
                    [ngClass]="tooltips.icon(row)"></span>
                </td>
              }

              @if (hasCustomMenu) {
                <td>
                  <gstar-action-menu
                    [actionMenu]="actionMenu"
                    [rowData]="row"></gstar-action-menu>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (dataSource.length === 0) {
        <p class="d-flex justify-content-center m-3">
          {{ noDataMessage }}
        </p>
      }
      @if (
        dataSource.length === 0 &&
        !this.filterIsEmpty() &&
        !isDataTableFirstLoading()
      ) {
        <p class="d-flex justify-content-center m-3">
          {{ noDataFilteredMessage }}
        </p>
      }
    </ap-table>
  }

  <gstar-grid-footer
    [data]="dataSource"
    [paginationSetting]="pagination"
    [options]="options"
    (pageChange)="updatePage($event)" />
</div>

@if (showDrawer) {
  <ap-drawer
    [visible]="!!selectedDrawerType"
    [placement]="'right'"
    [mask]="false"
    [drawerTitle]="selectedDrawerType?.title ?? ''"
    [resizable]="false"
    (onClose)="drawerCloseClick()">
    @if (selectedDrawerType) {
      <ng-container
        *ngComponentOutlet="
          selectedDrawerType.component;
          inputs: selectedDrawerType.componentInputs
        " />
    }
    <ng-template ngTemplate="footer">
      <div class="d-flex gap-2">
        @for (button of selectedDrawerType?.buttons; track button) {
          <ap-button
            [btnType]="button.isPrimary ? 'primary' : 'secondary'"
            (onClick)="
              button.command?.(drawerCloseClick.bind(this), selectedDrawerData!)
            "
            [disabled]="button.isPrimary ? !selectedDrawerData?.isValid : false"
            [label]="button.label" />
        }
      </div>
    </ng-template>
  </ap-drawer>
}
